<template>
  <card
    v-if="card.visible"
    :id="card.id"
    :key="card.id"
    :title="card.title"
    :class="{ 'card-disabled': card.disabled }"
  >
    <component
      :is="card.component.name"
      v-if="card.component"
      :key="card.component.key"
      :content="card.component.content"
      @click="handleClick"
    />
    <infotip
      v-if="card.disabled"
      :id="card.id + '-disabled'"
      :key="card.id + '-infotip-disabled'"
      :text="card.disabledMessage || 'A funcionalidade está temporariamente em manutenção.'"
      :auto-open-on-first-days="false"
      :never-open-again-after-dismissed="false"
      :close-on-mouse-leave="true"
    />
  </card>
</template>

<script>
import Card from '../Card'
import Infotip from '@/components/common/infotip/Infotip'
import CountIndicator from '../Widgets/CountIndicator'
import { mapActions, mapGetters } from 'vuex'
import Moment from 'moment'
import {
  PENDENCIES_PERIOD_DAYS_DEFAULT,
  PENDENCIES_STATUS_PENDING,
  PENDENCIES_ORDER_BY_SEND_DATE
} from '@/enums'

export default {
  name: 'CardPendencies',
  components: {
    card: Card,
    infotip: Infotip,
    'count-indicator': CountIndicator
  },
  computed: {
    ...mapGetters(['getUpdateTime', 'totalPendenciesQuantity', 'toggle', 'profile']),
    card () {
      return {
        id: 'pendencies',
        visible: !this.toggle.covax,
        disabled: !this.toggle.pendenciesManagement,
        title: 'Pendências',
        subtitleRegular: 'atualizado agora',
        updateTimeVisible: true,
        toggle: 'pendenciesManagement',
        component: {
          name: 'count-indicator',
          content: {
            number: this.toggle.pendenciesManagement === true ? this.totalPendenciesQuantity : 0,
            text: '',
            color: 'red',
            icon: 'exclamation',
            action: 'pendencies',
            sizeBig: true
          }
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'setCurrentTabPendencies'
    ]),
    handleClick() {
      this.setCurrentTabPendencies(1)
      this.$router.push({
        path: '/pendencies/list',
        query: {
          startDate: Moment(new Date())
            .subtract(PENDENCIES_PERIOD_DAYS_DEFAULT, 'days')
            .format('DD/MM/YYYY'),
          endDate: Moment(new Date()).format('DD/MM/YYYY'),
          status: [PENDENCIES_STATUS_PENDING],
          orderBy: PENDENCIES_ORDER_BY_SEND_DATE,
        }
      })
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Dashboard Novo',
        action: 'pendencies',
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    }
  }
}
</script>
